import { observer } from 'mobx-react';

import { ErrorMessage } from '../../../app/shared/components/Input/ErrorMessages/ErrorMessages';
import Button from '../../ui/Button/Button';
import { ModalBody, ModalContent, ModalFooter, ModalHeader, ModalHeading } from '../../ui/Modal/Modal';
import css from './ConfirmationModal.css';
import ConfirmationModalState from './ConfirmationModalState';

interface ConfirmationModalProps {
  state: ConfirmationModalState;
}

const ConfirmationModal = observer(({ state }: ConfirmationModalProps) => {
  const { pendingAction } = state;

  if (!pendingAction) {
    return null;
  }

  return (
    <ModalContent size="small" isDismissable={!state.isPending} isOpen={state.visible} onOpenChange={state.toggle}>
      <ModalHeader closeLabel={pendingAction.translation.closeLabel} isCloseDisabled={state.isPending}>
        <ModalHeading>{pendingAction.translation.heading}</ModalHeading>
      </ModalHeader>
      <ModalBody className={css.body}>
        <p className={css.message}>{pendingAction.message}</p>
        {state.errorMessage && (
          <div role="alert" className={css.error}>
            <ErrorMessage error={state.errorMessage} />
          </div>
        )}
      </ModalBody>
      <ModalFooter className={css.footer}>
        <Button slot="close" theme="primary" variant="outline" isDisabled={state.isPending}>
          {pendingAction.translation.cancelLabel}
        </Button>
        <Button theme="primary" variant="solid" isPending={state.isPending} onClick={state.confirm}>
          {state.isPending ? pendingAction.translation.confirmPendingLabel : pendingAction.translation.confirmLabel}
        </Button>
      </ModalFooter>
    </ModalContent>
  );
});

export default ConfirmationModal;
